import type { ThemeFontStack } from '@lognai/plugin-analytics';

/** Curated local font library. Web fonts are self-hosted with the application. */
export const THEME_FONT_LIBRARY: Array<{
  id: ThemeFontStack;
  name: string;
  category: string;
  family: string;
}> = [
  {
    id: 'app',
    name: 'Geist · App default',
    category: 'Sans serif',
    family: 'Geist, Inter, ui-sans-serif, system-ui, sans-serif',
  },
  {
    id: 'inter',
    name: 'Inter',
    category: 'Sans serif',
    family: 'Inter, ui-sans-serif, system-ui, sans-serif',
  },
  {
    id: 'barlow',
    name: 'Barlow',
    category: 'Sans serif',
    family: 'Barlow, ui-sans-serif, system-ui, sans-serif',
  },
  {
    id: 'barlow-semi-condensed',
    name: 'Barlow Semi Condensed',
    category: 'Sans serif · Semi condensed',
    family: '"Barlow Semi Condensed", ui-sans-serif, system-ui, sans-serif',
  },
  {
    id: 'space-grotesk',
    name: 'Space Grotesk',
    category: 'Sans serif',
    family: '"Space Grotesk", ui-sans-serif, system-ui, sans-serif',
  },
  {
    id: 'ibm-plex-mono',
    name: 'IBM Plex Mono',
    category: 'Monospace',
    family: '"IBM Plex Mono", ui-monospace, monospace',
  },
  {
    id: 'presentation-serif',
    name: 'Georgia',
    category: 'Serif',
    family: 'Georgia, Cambria, "Times New Roman", serif',
  },
  {
    id: 'system-sans',
    name: 'System sans',
    category: 'System',
    family: 'ui-sans-serif, system-ui, -apple-system, sans-serif',
  },
];
export const THEME_FONTS = Object.fromEntries(
  THEME_FONT_LIBRARY.map((font) => [font.id, font.family])
) as Record<ThemeFontStack, string>;
